export const GROUP_ITEMS_PAGE_SIZE = 25;
export const ITEMS_SEARCH_DEBOUNCE_MS = 400;

export const GroupItemsStatus = {
  IDLE: 'idle',
  LOADING: 'loading',
  LOADING_MORE: 'loadingMore',
  LOADED: 'loaded',
  ERROR: 'error',
};

export const LOAD_MORE_LABEL = 'Load more';
export const EMPTY_ITEMS_MESSAGE = 'No requests found for this group.';
export const FILTERED_EMPTY_ITEMS_MESSAGE = 'No requests match the current search.';
export const ERROR_ITEMS_MESSAGE = 'Failed to load requests.';
